export default "__VITE_ASSET__CPOoZKY0__"